<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Retraites de fin d'initiation" />
            <RetraiteSpirituel />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import RetraiteSpirituel from './LesRetraiteSpirituel.vue';


export default {
    name: 'RetraitePage',
    components: {
        NavBar,
        PageTitle,
        RetraiteSpirituel,
        FooterComp,
    }
}
</script>